<template>
	<div class="wrongQuestion ">
		<el-input v-model="key" class="h-[58px] text-[16px] mb-[10px]" @change="change"
			:placeholder="langInfo.study_keywords_search"></el-input>
		<div class="" v-if="isFinish&&subjectList.length>0">
			<div style="min-height: 500px;">
				<div :class="item.is_expired==1?'bg-[#e7e9eb]':''" v-for="(item,index) in subjectList" :key="index"
					class="no-underline py-[20px] px-[16px] box-border  bB-03  mb-[12px] ">
					<div class="rounded-[5px]   flex items-center justify-between">
						<div class="flex-1 flex">
							<el-image class="w-[147px] h-[112px] mr-[14px] rounded-[6px]"
								:src="item.courseSubject.image" fit="cover"></el-image>
							<div class="flex-1 ">
								<div class="text-[16px] text-[#000000]  mb-[10px] flex items-center justify-between">
									<div class="yw-text-cut-1">
										{{item.courseSubject.name}}
									</div>
									<div @click="subjectInfoClick(item,index)"
										class="w-[200px] cursor-pointer text-right text-[#2979FF] text-[12px] ml-[20px]">
										{{langInfo.study_subject_view}}>>
									</div>
								</div>
								<div class="flex items-center mb-[8px] text-[12px]">
									<div class="flex items-center min-w-[90px] mr-[10px]">
										<img src="@/static/image/icon25.png" class="w-[15px] h-[15px] mr-[10px]" />
										<div class="flex-1  text-[#A2A2A2]">
											{{langInfo.study_subject_title}}
										</div>
									</div>
									<div class="flex-1  text-[#0F1419]">
										{{langInfo.study_total}}{{item.course_chapter_small_count}}{{langInfo.study_chapter}}
										| {{item.question_count}}{{langInfo.dao_question}}｜ <label
											class="text-[#0080FF]">{{langInfo.study_collect}}{{item.user_collection_count}}{{langInfo.way}}</label>
									</div>
								</div>

								<div class="flex items-center mb-[10px]  text-[12px]">
									<div class="flex items-center min-w-[90px] mr-[10px]">
										<img src="@/static/image/icon35.png" class="w-[15px] h-[15px] mr-[10px]" />
										<div class="  text-[#A2A2A2]">
											{{langInfo.study_exam_title}}
										</div>
									</div>
									<div class="flex-1  text-[#0F1419]">
										{{langInfo.study_exam_duration}}{{item.courseSubject.exam_duration}}min；{{langInfo.study_exam_total}}{{item.courseSubject.total_score}}；{{langInfo.study_exam_pass}}{{item.courseSubject.qualified_score_line}}
										<!-- <label class="cursor-pointer text-[#2979FF] ml-[20px]"
										@click="examInfoClick(item,index)">{{langInfo.exam_infor_details}}>></label> -->
									</div>
								</div>
								<div class="flex items-center mb-[8px] text-[12px] text-[#FF0000]">
									{{langInfo['validity_period']}}:{{item.expiration_date}}
								</div>
								<div class="text-[#FF0000] text-[12px] mt-[5px]" v-if="item.is_expired==1">
									{{langInfo.study_subject_overdue}}
								</div>

							</div>
						</div>
						<div class="flex items-center cursor-pointer text-[#FF0000] text-[14px]"
							@click="showClick(item,index)">
							<label v-if="item.isShow" class=" mr-[2px] cursor-pointer">{{langInfo['Click Collapse']}}</label>
							<label v-else-if="!item.isShow" class=" mr-[2px] cursor-pointer">{{langInfo['Click to expand']}}</label>
							<img v-if="item.isShow" src="@/static/image/icon32.png"
								class="w-[24px] h-[24px] cursor-pointer" />
							<img v-else-if="!item.isShow" src="@/static/image/icon33.png"
								class="w-[24px] h-[24px] cursor-pointer" />
						</div>
					</div>
					<div class="pt-[20px] px-[30px] box-border" v-if="item.isShow">
						<div class="" v-if="item.isFinish&&item.chapterList.length>0">
							<div v-for="(itm,ind) in item.chapterList" :key="ind"
								class="mb-[10px] bg-[#F7F9FC] py-[16px] px-[20px] box-border flex items-center justify-between">
								<label>{{itm.chapter_name}}</label>
								<div class="flex items-center">
									<label
										class=" text-[#0080FF] mr-[14px]">{{langInfo.study_collect}}：{{itm.user_collection_count}}{{langInfo.way}}</label>
									<div @click.stop="reciteQuestionsMode(item,index,itm,ind)"
										class="px-[10px] box-border whitespace-nowrap h-[30px] mr-[10px] cursor-pointer  leading-[30px] no-underline border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center ">
										{{langInfo.study_collect_view}}
									</div>
									<div @click.stop="startExercise(item,index,itm,ind)"
										class="px-[10px] box-border whitespace-nowrap h-[30px] leading-[30px] cursor-pointer border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
										{{langInfo.study_collect_start}}
									</div>
								</div>
							</div>
						</div>
						<emptyPage v-else-if="item.isFinish&&item.chapterList.length==0"
							:title="langInfo.no_chapter_records">
						</emptyPage>
					</div>
				</div>
			</div>
			<div class="flex justify-center">
				<el-pagination :page-size="pageSize" :total="total" :current-page="page" @current-change="currentChange"
					background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>
		<emptyPage v-else-if="isFinish&&subjectList.length==0" :title="langInfo.no_chapter_records"></emptyPage>

		<!-- 科目介绍 -->
		<el-dialog :title="langInfo.study_subject_title" :visible.sync="subjectVisible" :close-on-click-modal="false"
			width="50%" center>

			<div class="max-h-[50vh] overflow-y-scroll" v-html="subjectBlurb">
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="subjectVisible = false">取 消</el-button>
				<el-button type="primary" @click="subjectVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 科目介绍 -->
		<!-- 考试信息 -->
		<el-dialog :title="langInfo.exam_infor_details" :visible.sync="examVisible" :close-on-click-modal="false"
			width="30%" center>
			<div class="">
				<div class="mb-[6px]">
					{{langInfo.study_exam_duration}}:{{courseSubject.exam_duration}}min
				</div>
				<div class="mb-[6px]">
					{{langInfo.study_exam_total}}:{{courseSubject.total_score}}
				</div>
				<div class="mb-[6px]">
					{{langInfo.study_exam_pass}}:{{courseSubject.qualified_score_line}}
				</div>
				<div class="mb-[6px]" v-if="courseSubject.count">
					{{langInfo.questions_number}}:{{courseSubject.count}}
				</div>
				<div class="" v-if="courseSubject.score">
					{{langInfo.single_question_score}}:{{courseSubject.score}}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="examVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="examVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 考试信息 -->

	</div>
</template>

<script>
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		name: "collection",
		components: {
			emptyPage
		},
		data() {
			return {
				key: '',
				// 科目
				page: 1,
				pageSize: 6,
				total: 0,
				isFinish: false,
				subjectList: [],
				subjectVisible: false, //科目介绍
				subjectBlurb: '',
				teacherVisible: false, //讲师介绍弹框
				examVisible: false, //考试信息
				courseSubject: {},
				langInfo: {}
			}
		},
		mounted() {

			this.getSubject()


			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				document.title = this.langInfo.pc_name+'-'+this.langInfo.study_my_fav;
			}

		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					document.title = this.langInfo.pc_name+'-'+this.langInfo.study_my_fav;
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			change(e) {
				console.log(e);
				this.key = e
				this.page = 1;
				this.total = 0
				this.isFinish = false

				this.getSubject()
			},
			currentChange(e) {
				this.page = e
				this.isFinish = false
				this.getSubject()
			},
			getSubject() {
				this.$api.getMyPapersWithSubject({
					page: this.page,
					pageSize: this.pageSize,
					key: this.key,
					is_subject_list: '1,4'
				}).then((res) => {
					console.log(res);
					this.subjectList = res.data.data

					this.subjectList.forEach((item, index) => {
						this.$set(item, 'isShow', false)
						this.$set(item, 'isFinish', false)
						this.$set(item, 'chapterList', [])
					})

					this.total = res.data.total
					this.isFinish = true
				}).catch((error) => {
					this.isFinish = true
					if (error.code == 450) {
						setTimeout(() => {
							const currentUrl = this.$route.fullPath;
							localStorage.setItem('loginRedirect', currentUrl);
							this.$router.replace({ path: '/login' })
						}, 800)
					}
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			showClick(item, index) {
				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				this.subjectList.forEach((itm, ind) => {
					if (index == ind) {
						itm.isShow = !itm.isShow

						if (itm.isShow) {
							itm.isFinish = false
							this.getChapterList(itm, index)
						}
					} else {
						itm.isShow = false
					}
				})
			},
			getChapterList(item, index) {
				this.$api.order_chapter({
					item_id: item.id,
				}).then((res) => {
					console.log(res.data);
					this.subjectList[index].chapterList = res.data

					item.isFinish = true

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			subjectInfoClick(item, index) {
				console.log(item.courseSubject.blurb);

				this.subjectBlurb = item.courseSubject.blurb
				this.subjectVisible = true
			},
			examInfoClick(item, index) {
				this.courseSubject = item.courseSubject
				this.examVisible = true
			},
			startExercise(item, index, itm, ind) {
				// 1章节练习   2收藏练习  
				if (itm.user_collection_count > 0) {
					this.$router.push({
						path: '/exam/chapterExercises',
						query: {
							order_item_id: item.id,
							id: itm.id,
							mode: 2
						}
					})
				} else {
					this.$message({
						message: this.langInfo.no_practice_questions_available,
						type: 'warning'
					})
				}
			},
			reciteQuestionsMode(item, index, itm, ind) {
				//mode 1章节练习   2收藏练习  
				if (itm.user_collection_count > 0) {
					this.$router.push({
						path: '/exam/reciteQuestionsMode',
						query: {
							orderId: item.id,
							id: itm.id,
							mode: 2
						}
					})
				} else {
					this.$message({
						message: this.langInfo.selected_chapter_no_available_tip,
						type: 'warning'
					})
				}
			}
		}
	}
</script>

<style scoped>
	/deep/input::placeholder {
		color: #888888;
	}

	/deep/.el-input__inner {
		height: 100%;
		border-color: #BBBBBB;
	}

	input::placeholder {
		color: #888888;
	}
</style>